import { encodeWav } from "./wavEncoder";

export const convertTo16kWav = async (audioChunks) => {
  const webmBlob = new Blob(audioChunks, { type: "audio/webm" });

  const audioContext = new (
    window.AudioContext || window.webkitAudioContext
  )();

  const originalBuffer = await audioContext.decodeAudioData(
    await webmBlob.arrayBuffer()
  );

  const sampleRate = 16000;

  const offlineContext = new OfflineAudioContext(
    1,
    Math.ceil(originalBuffer.duration * sampleRate),
    sampleRate
  );

  const source = offlineContext.createBufferSource();
  source.buffer = originalBuffer;
  source.connect(offlineContext.destination);
  source.start();

  const renderedBuffer = await offlineContext.startRendering();

  return encodeWav(renderedBuffer.getChannelData(0), sampleRate);
};